<template>
  <section id="top" class="relative min-h-screen bg-cream flex items-center overflow-hidden">

    <div class="absolute inset-0 pointer-events-none">
      <div class="absolute top-0 right-0 w-1/2 h-full bg-sand hidden md:block" style="clip-path: polygon(12% 0, 100% 0, 100% 100%, 0% 100%)"></div>
    </div>

    <div class="relative max-w-6xl mx-auto px-6 w-full pt-24 pb-8 md:pt-28 md:pb-12 flex flex-col md:flex-row items-center gap-10 md:gap-0">

      <div class="flex-1 md:pr-16 fade-up text-center md:text-left">
        <p class="section-label mb-5">Terapi &amp; Samtal · Stockholm</p>
        <h1 class="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-light leading-none text-charcoal mb-6">
          En möjlighet<br>
          <em class="not-italic text-terra">till förändring</em>
        </h1>
        <p class="text-base md:text-xl text-muted font-light leading-relaxed mb-4 max-w-md mx-auto md:mx-0">
          Gemensamt hittar vi en annan väg.
        </p>
        <p class="text-sm md:text-base text-muted font-light leading-relaxed mb-8 max-w-md mx-auto md:mx-0">
          Kan en inre trygghet skapas genom acceptans, insikt och förståelse om mig själv?
        </p>
        <div class="hidden md:flex flex-row justify-start gap-3 fade-up fade-up-delay-2">
          <a href="mailto:carina@carinalandin.se" class="btn-primary text-center">Kontakta mig</a>
          <a href="#om-mig" class="btn-outline text-center">Läs mer</a>
        </div>
        <p class="hidden md:block mt-6 text-sm text-muted fade-up fade-up-delay-3">
          <a href="mailto:carina@carinalandin.se" class="hover:text-terra transition-colors">carina@carinalandin.se</a>
        </p>

        <!-- Photo + email shown only on mobile -->
        <div class="md:hidden mt-6 flex flex-col items-center gap-4 fade-up fade-up-delay-2">
          <div class="w-48 sm:w-60 relative">
            <div class="absolute -inset-3 rounded-full" style="background: var(--color-sage); opacity: 0.15;"></div>
            <img
              src="@/assets/carinalandin.png"
              alt="Carina Landin"
              class="relative w-full rounded-full object-cover shadow-lg"
              style="aspect-ratio: 1; object-fit: cover;"
            />
          </div>
          <a href="mailto:carina@carinalandin.se" class="text-sm text-muted hover:text-terra transition-colors">carina@carinalandin.se</a>
        </div>
      </div>

      <div class="hidden md:block flex-shrink-0 md:w-96 lg:w-[28rem] fade-up fade-up-delay-1">
        <div class="relative">
          <div class="absolute -inset-3 rounded-full" style="background: var(--color-sage); opacity: 0.15;"></div>
          <img
            src="@/assets/carinalandin.png"
            alt="Carina Landin"
            class="relative w-full rounded-full object-cover shadow-lg"
            style="aspect-ratio: 1; object-fit: cover;"
          />
        </div>
      </div>
    </div>

    <div class="absolute bottom-8 left-1/2 -translate-x-1/2 opacity-30">
      <div class="w-px h-10 bg-muted mx-auto"></div>
    </div>
  </section>
</template>

<script>
export default {};
</script>
